import apiClient from '../../lib/axios';

export const fetchExchangeRates = async ({ page = 1, pageSize = 10, fromCurrency, toCurrency, isActive } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (fromCurrency) params.append('fromCurrency', fromCurrency);
  if (toCurrency) params.append('toCurrency', toCurrency);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  const { data } = await apiClient.get(`/api/exchange-rates?${params.toString()}`);
  return data;
};

export const createExchangeRate = async (payload) => {
  const { data } = await apiClient.post('/api/exchange-rates', payload);
  return data;
};

export const updateExchangeRate = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/exchange-rates/${id}`, payload);
  return data;
};

export const deleteExchangeRate = async (id) => {
  const { data } = await apiClient.delete(`/api/exchange-rates/${id}`);
  return data;
};

export default fetchExchangeRates;
